import { DownloadSimple } from '@phosphor-icons/react';
import { Inline, LinkButton } from '@etg/wings';
import { useSnowplowTracking, useTranslation } from '@eti/providers';
import { useToggle } from '../../../../../common/custom-hooks/toggle';
import { routes } from '../../../../../constants/routesAndApisConstants';
import ReceiptDialog from '../../common/ReceiptDialog';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import type { SnowplowEventDataType } from '../../../models';

interface ReceiptProps {
  hasIcon?: boolean;
  snowplow?: SnowplowEventDataType;
}

const Receipt = ({ hasIcon = false, snowplow }: ReceiptProps) => {
  const { t } = useTranslation();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();
  const { addOnOrders } = useOrderDetails();
  const {
    isOpen: isDownloadReceiptDialogOpen,
    handleClose: handleCloseDownloadReceiptDialog,
    handleOpen: handleOpenDownloadReceiptDialog,
  } = useToggle(false);

  const hasAddOnOrders = addOnOrders && addOnOrders?.length > 0;

  const handleSnowplowOnDownloadReceipt = () => {
    if (isSnowplowTrackingEnabled) {
      sendTrackEvent({
        category: snowplow?.category,
        action: 'Click',
        label: snowplow?.label,
      });
    }
  };

  const handleOnDownloadReceipt = () => {
    handleSnowplowOnDownloadReceipt();
    handleOpenDownloadReceiptDialog();
  };

  return (
    <>
      <Inline spacing={4}>
        {hasIcon && <DownloadSimple aria-hidden="true" size={20} />}
        {hasAddOnOrders ? (
          <LinkButton data-testid="create-receipt-button" onClick={handleOnDownloadReceipt}>
            {t('OrderDetails.Payment.Overview.DownloadReceiptButton.Label')}
          </LinkButton>
        ) : (
          <a
            aria-label={`${t('OrderDetails.Payment.Overview.DownloadReceiptButton.Label')}, ${t(
              'ScreenReader.Link.OpensInNewTab.AriaLabel.Text',
            )}`}
            data-testid="create-receipt-button"
            href={`${routes.RECEIPT_PDF}`}
            onClick={handleSnowplowOnDownloadReceipt}
            rel="noreferrer"
            target="_blank"
          >
            {t('OrderDetails.Payment.Overview.DownloadReceiptButton.Label')}
          </a>
        )}
      </Inline>
      {hasAddOnOrders && (
        <ReceiptDialog
          isOpen={isDownloadReceiptDialogOpen}
          onDismiss={handleCloseDownloadReceiptDialog}
        />
      )}
    </>
  );
};

export default Receipt;
